import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../../api/DBSchema/Gateway';
import {SMCRadio} from '../../../../../components/Simple/SMCRadio';
import {useTranslation} from 'react-i18next';
import PlanEditorInnerContainer from '../../../../../components/Editor/PlanEditorInnerContainer';
import Separator from '../../../../../components/Simple/Sepperator';
import SMCTextInput from '../../../../../components/Simple/SMCTextInput';
import Indentation from '../../../../../components/Simple/Indentation';
import SMCLabel from '../../../../../components/Simple/SMCLabel';
import EmptyRow from '../../../../../components/Simple/EmptyRow';
import EditorLayout from '../../../../../components/Layouts/EditorLayout';
import {SMCToggleSwitch} from "../../../../../components/Simple/SMCToggleSwitch";

const pageSchema = GatewayGetSchema.pages.dns;
const pageId = pageSchema.pageId;

function BaseDns({
    pageData,
    setObjectData,
    pageDisabled
}) {
    const { t } = useTranslation();

    const managedInSmp              = pageData[pageSchema.manageInSmp];
    const configureDnsServers       = pageData[pageSchema.configureDnsServers];
    const firstDnsServer            = pageData[pageSchema.firstDnsServer];
    const secondDnsServer           = pageData[pageSchema.secondDnsServer];
    const thirdDnsServer            = pageData[pageSchema.thirdDnsServer];
    const enableDnsProxy            = pageData[pageSchema.enableDnsProxy];
    const resolveNetworkObjects     = pageData[pageSchema.resolveNetworkObjects];
    const domainName                = pageData[pageSchema.domainName];
    
    const configureDnsServersValues = pageSchema.configureDnsServersValues;

    const useGlobalDNSServers       = configureDnsServers === configureDnsServersValues.GLOBAL;
    const useInternetDNSServers     = configureDnsServers === configureDnsServersValues.INTERNET;

    const setPageValue = useCallback((param, newValue) => {
        if (!pageDisabled) {
            setObjectData([pageId, param], newValue);
        }
    }, [setObjectData, pageDisabled]);

    return (
        <EditorLayout>
            <SMCToggleSwitch
                disabled={pageDisabled}
                checked={managedInSmp}
                onChange={checked => setPageValue(pageSchema.manageInSmp, checked)}
                label={t('SMP.PLAN.MANAGE_IN_SMP')}
            />
            <Separator isMainSeparator/>
            <PlanEditorInnerContainer managedInSmp={managedInSmp}>
                <SMCLabel bold>{t('SMP.PLAN.NEW_PLAN_DS.DNS.DNS_SERVERS')}</SMCLabel>
                <SMCRadio
                    disabled={pageDisabled || !managedInSmp}
                    checked={useGlobalDNSServers}
                    onChange={() => setPageValue(pageSchema.configureDnsServers, configureDnsServersValues.GLOBAL)}
                    label={t('SMP.PLAN.NEW_PLAN_DS.DNS.CONFIGURE_DNS_SERVERS')}
                />
                <Indentation>
                    <SMCLabel>{t('SMP.PLAN.NEW_PLAN_DS.DNS.LINE1')}</SMCLabel>
                    <SMCTextInput
                        disabled={pageDisabled || !managedInSmp || !useGlobalDNSServers}
                        value={firstDnsServer}
                        onChange={e => setPageValue(pageSchema.firstDnsServer, e.target.value)}
                        label={t('SMP.PLAN.NEW_PLAN_DS.DNS.FIRST_DNS')}
                    />
                    <SMCTextInput
                        disabled={pageDisabled || !managedInSmp || !useGlobalDNSServers}
                        value={secondDnsServer}
                        onChange={e => setPageValue(pageSchema.secondDnsServer, e.target.value)}
                        label={t('SMP.PLAN.NEW_PLAN_DS.DNS.SECOND_DNS')}
                    />
                    <SMCTextInput
                        disabled={pageDisabled || !managedInSmp || !useGlobalDNSServers}
                        value={thirdDnsServer}
                        onChange={e => setPageValue(pageSchema.thirdDnsServer, e.target.value)}
                        label={t('SMP.PLAN.NEW_PLAN_DS.DNS.THIRD_DNS')}
                    />
                </Indentation>
                <SMCRadio
                    disabled={pageDisabled || !managedInSmp}
                    checked={useInternetDNSServers}
                    onChange={() => setPageValue(pageSchema.configureDnsServers, configureDnsServersValues.INTERNET)}
                    label={t('SMP.PLAN.NEW_PLAN_DS.DNS.LINE2')}
                />

                <EmptyRow />

                <SMCLabel bold>{t('SMP.PLAN.NEW_PLAN_DS.DNS.DNS_PROXY')}</SMCLabel>
                <div style={{ lineHeight: '22px' }}>
                    <SMCToggleSwitch
                        disabled={pageDisabled || !managedInSmp}
                        checked={enableDnsProxy}
                        onChange={checked => setPageValue(pageSchema.enableDnsProxy, checked)}
                        label={t('SMP.PLAN.NEW_PLAN_DS.DNS.ENABLE_DNS_PROXY')}
                    />
                    <SMCLabel>{t('SMP.PLAN.NEW_PLAN_DS.DNS.LINE3')}</SMCLabel>
                    <SMCToggleSwitch
                        disabled={pageDisabled || !managedInSmp}
                        checked={resolveNetworkObjects}
                        onChange={checked => setPageValue(pageSchema.resolveNetworkObjects, checked)}
                        label={t('SMP.PLAN.NEW_PLAN_DS.DNS.RES_NET_OBJ')}
                    />
                    <SMCLabel>{t('SMP.PLAN.NEW_PLAN_DS.DNS.LINE4')}</SMCLabel>
                </div>
                
                <EmptyRow />

                <SMCLabel bold>{t('SMP.PLAN.NEW_PLAN_DS.DNS.DOMAIN_NAME')}</SMCLabel>
                <SMCTextInput
                    disabled={pageDisabled || !managedInSmp}
                    value={domainName}
                    onChange={e => setPageValue(pageSchema.domainName, e.target.value)}
                    label={t('SMP.PLAN.NEW_PLAN_DS.DNS.DOMAIN_NAME')}
                />
            </PlanEditorInnerContainer>
        </EditorLayout>
    );
}

export default BaseDns;